module.exports = __webpack_public_path__ + "img/medalSilver.d6c6a57a.png";